module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.fields), function(field, index) {
    return _c('InterfaceField', {
      key: index,
      attrs: {
        "field": field,
        "record": _vm.record,
        "settings": {
          editing: false
        },
        "element": field
      },
      on: {
        "change": _vm.fieldChanged,
        "input": _vm.fieldInput,
        "button": _vm.buttonClicked
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce3a773"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/AdvancedPanel.vue
// module id = 2493
// module chunks = 1